export default __webpack_public_path__ + "static/media/Background_00196.70c0bd91.png";